import {Component} from '@angular/core';

/**
 * Основной заголовок страницы
 */

@Component({
    selector: 'app-main-title',
    template: `
        <h1>
            <ng-content></ng-content>
        </h1>
    `,
    styles: [`
        h1 {
            margin: 10px 0;
        }
    `]
})
export class MainTitleComponent {}
